import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constants} from '../config/constants.config';
import {BaseUserViewModel, UserFriendViewModel} from '../viewModels/userFriend.viewModel';
import {CreateUserFriendDto} from '../dto/createUserFriend.dto';
import {SearchFriendDto} from '../dto/searchFriend.dto';
import {DeleteUserFriendDto} from '../dto/deleteUserFriend.dto';

@Injectable()
export class FriendsService {
    constructor(private readonly httpClient: HttpClient, private readonly constants: Constants) {
    }

    createFriend(createUserFriendDTO: CreateUserFriendDto): Observable<void> {
        return this.httpClient.post<void>(`${this.constants.apiURL()}/user/friends/`, createUserFriendDTO);
    }

    removeFriend(deleteUserFriendDto: DeleteUserFriendDto): Observable<void> {
        const params = new HttpParams()
            .append('id', deleteUserFriendDto.id + '');
        const headers = new HttpHeaders({'Content-Type': 'application/JSON'});

        return this.httpClient.delete<void>(`${this.constants.apiURL()}/user/friends/`, {headers: headers, params: params});
    }

    getFriends(): Observable<UserFriendViewModel[]> {
        return this.httpClient.get<UserFriendViewModel[]>(`${this.constants.apiURL()}/user/friends/`);
    }

    searchFriends(searchFriendDTO: SearchFriendDto): Observable<BaseUserViewModel[]> {
        return this.httpClient.post<BaseUserViewModel[]>(`${this.constants.apiURL()}/user/friends/search/`, searchFriendDTO);
    }

}
